import React from "react";
import { Body } from "../Common/Typography";
import { BorderWrapper, CommentWrapper } from "./__styles__/Comment";

export interface CommentProps {
  content: string;
  truncate: boolean;
}

const Comment = ({ content, truncate }: CommentProps) => {
  return (
    <CommentWrapper>
      <BorderWrapper truncate={truncate}>
        <Body size="default" type="regular">
          {content}
        </Body>
      </BorderWrapper>
    </CommentWrapper>
  );
};

export default Comment;
